import { call, all, put, takeLatest } from 'redux-saga/effects';
import { EXAM_REQUEST_TYPES, EXAM_TYPES, examDetailsActionTypes } from './Constants';
import { processRequest } from '../../services/Api';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as examDetailsActions from './Actions';

export default function* () {
	yield all([takeLatest(examDetailsActionTypes.GET_EXAM_DETAILS, handleExamDetailsRequest)]);
}

export function* handleExamDetailsRequest({ payload }) {
	try {
		const { data } = payload || {};
		const { id, type, isPublic } = data || {};

		const { data: respData } = yield call(
			processRequest,
			`${isPublic ? 'public/' : ''}${EXAM_REQUEST_TYPES[type]}/${id}`,
			'GET',
		);
		yield put(
			examDetailsActions.getExamDetailsSuccess({
				...respData[EXAM_TYPES[type]],
				no_index: respData.no_index,
			}),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(examDetailsActions.getExamDetailsError());
	}
}
